/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyWebhookDelivery } from "./CompanyWebhookDelivery";
import {
  CompanyWebhookDeliveryFromJSON,
  CompanyWebhookDeliveryFromJSONTyped,
  CompanyWebhookDeliveryToJSON,
  CompanyWebhookDeliveryToJSONTyped,
} from "./CompanyWebhookDelivery";

/**
 * One delivery and its whole chain: the original send and every redelivery, oldest first.
 * @export
 * @interface WebhookDeliveryDetail
 */
export interface WebhookDeliveryDetail {
  /**
   *
   * @type {CompanyWebhookDelivery}
   * @memberof WebhookDeliveryDetail
   */
  delivery: CompanyWebhookDelivery;
  /**
   *
   * @type {Array<CompanyWebhookDelivery>}
   * @memberof WebhookDeliveryDetail
   */
  attempts: Array<CompanyWebhookDelivery>;
}

/**
 * Check if a given object implements the WebhookDeliveryDetail interface.
 */
export function instanceOfWebhookDeliveryDetail(
  value: object,
): value is WebhookDeliveryDetail {
  if (!("delivery" in value) || value["delivery"] === undefined) return false;
  if (!("attempts" in value) || value["attempts"] === undefined) return false;
  return true;
}

export function WebhookDeliveryDetailFromJSON(
  json: any,
): WebhookDeliveryDetail {
  return WebhookDeliveryDetailFromJSONTyped(json, false);
}

export function WebhookDeliveryDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): WebhookDeliveryDetail {
  if (json == null) {
    return json;
  }
  return {
    delivery: CompanyWebhookDeliveryFromJSON(json["delivery"]),
    attempts: (json["attempts"] as Array<any>).map(
      CompanyWebhookDeliveryFromJSON,
    ),
  };
}

export function WebhookDeliveryDetailToJSON(json: any): WebhookDeliveryDetail {
  return WebhookDeliveryDetailToJSONTyped(json, false);
}

export function WebhookDeliveryDetailToJSONTyped(
  value?: WebhookDeliveryDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    delivery: CompanyWebhookDeliveryToJSON(value["delivery"]),
    attempts: (value["attempts"] as Array<any>).map(
      CompanyWebhookDeliveryToJSON,
    ),
  };
}
